import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { List, GetTopProduct } from '../../services/seller.service';
import { getuser } from '../../helpers/user.helper';
import formatMoney from '../../helpers/money.helper';
import formatDate from '../../helpers/date.helper';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import * as ListUser from '../../services/user.service';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';

export default function ContentUserDashboard() {
    let navigate = useNavigate();
    const [vendasArray, setVendas] = useState(undefined);
    const [vendasCompletasArray, setVendasCompletas] = useState(undefined);
    const [totalVendas, setTotalVendas] = useState(undefined);
    const [topProduct, setTopProduct] = useState(undefined);
    const [qtdVendas, setQtdVendas] = useState(undefined);
    const [totalUsers, setTotalUsers] = useState(undefined);


    useEffect(() => {
        let user = getuser();
        //Redireciona caso não esteja logado 
        if (!user) {
            navigate('/login');
        }

        async function fetchData() {
            let vendas = await List();
            let topProduct = await GetTopProduct();
            let arraySlice = vendas?.data.slice(0, 10);
            let totalVendas = vendas?.data.length;
            let totalUsers = await ListUser.List();
            setVendasCompletas(vendas?.data);
            setQtdVendas(totalVendas);
            setVendas(arraySlice);
            setTotalUsers(totalUsers?.data.length);
            setTopProduct(topProduct?.data);
        }

        fetchData();
    }, [])

   
    const showItemClick = (rowData) => {
        navigate(`/venda/${rowData.id}`)
    }

    const getTotal = (total, num, qtd) => {
        let preco = parseFloat(num.total);
        return total + Math.round(preco);
    }


    const optionButtons = (rowData, column) => {
        return (
            <div>
                <button onClick={() => showItemClick(rowData)} title="Visualizar item" type="button" className="btn btn-icon btn-danger btn-sm"><i className="fa fa-search"></i></button>
            </div>
        )
    }

    return (
        <>
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Dashboard</h1>
                            </div>

                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-info">
                                    <div className="inner">
                                        <h3>{qtdVendas}</h3>
                                        <p>Qtd. Vendas</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-bag" />
                                    </div>
                                    {/* <a href="#" className="small-box-footer">Detalhar <i className="fas fa-arrow-circle-right" /></a> */}
                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-success">
                                    <div className="inner">
                                        <h3>{vendasCompletasArray && formatMoney(vendasCompletasArray.reduce(getTotal, 0))}</h3>
                                        <p>Total Vendido</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-stats-bars" />
                                    </div>
                                    {/* <a href="#" className="small-box-footer">Detalhar <i className="fas fa-arrow-circle-right" /></a> */}
                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                <div className="small-box bg-warning">
                                    <div className="inner">
                                        <h3>{vendasCompletasArray && formatMoney(((30 * vendasCompletasArray.reduce(getTotal, 0)) / 100))}</h3>
                                        <p>Comissão</p>                                        
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-person-add" />
                                    </div>
                                    {/* <a href="#" className="small-box-footer">Detalhar <i className="fas fa-arrow-circle-right" /></a> */}
                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                {/* small box */}
                                <div className="small-box bg-danger">
                                    <div className="inner">
                                        <h3>{vendasCompletasArray && formatMoney((vendasCompletasArray.reduce(getTotal, 0) - ((30 * vendasCompletasArray.reduce(getTotal, 0)) / 100)))}</h3>
                                        <p>Total Devido</p>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-pie-graph" />
                                    </div>
                                    {/* <a href="#" className="small-box-footer">Detalhar <i className="fas fa-arrow-circle-right" /></a> */}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {/* Left col */}
                            <section className="col-lg-12 connectedSortable">
                                {/* Custom tabs (Charts with tabs)*/}
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            <i className="fas fa-chart-pie mr-1" />Ultimas Vendas
                                        </h3>
                                        <div className="card-tools">
                                            <ul className="nav nav-pills ml-auto">
                                                <li className="nav-item">
                                                    <a className="nav-link active" href="#revenue-chart" data-toggle="tab">Nova venda</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content p-0">
                                            <DataTable value={vendasArray} style={{ marginBottom: 50 }} responsive className="p-datatable-customers"
                                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                                                emptyMessage="Você não possui dados"
                                            >
                                                <Column field="id" header="Código" />
                                                <Column field={(row) => formatDate(row.dataImportacao)} header="Data" />
                                                <Column field={(row) => row.usuario && row.usuario.nome} header="Usuário" />
                                                <Column field={(row) => formatMoney(row.total)} header="Valor" />
                                                <Column key="123" body={optionButtons} bodyStyle={{ textAlign: 'center', overflow: 'hidden' }} />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
